document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.lp-contact-form');
  if (!section) return;

  const form = section.querySelector('#contact_form');
  const progressBar = section.querySelector('.contact-progress-bar');
  const fields = section.querySelectorAll('input, textarea, select');
  const fieldInnerContainers = section.querySelectorAll('.contact-field-inner');
  const formFields = section.querySelector('.contact-fields');
  const submitButton = section.querySelector('.contact-submit-button');
  const termsText = section.querySelector('.contact-bottom-text');
  const successMessage = section.querySelector('#contact-success-message');

  // === Shopify form success handling ===
  const urlParams = new URLSearchParams(window.location.search);
  const formSubmitted = urlParams.has('contact_posted');

  if (formSubmitted && successMessage) {
    formFields?.style.setProperty('display', 'none');
    submitButton?.style.setProperty('display', 'none');
    termsText?.style.setProperty('display', 'none');
    successMessage.style.display = 'block';
  }

  // === Progress bar logic ===
  function updateProgressBar() {
    let filledFields = 0;
    let countableFields = 0;

    fieldInnerContainers.forEach(container => {
      const containerFields = container.querySelectorAll('input, textarea, select');
      let checkboxGroupChecked = false;
      let hasCheckbox = false;

      containerFields.forEach(field => {
        if (field.offsetParent !== null && !field.disabled && field.type !== 'submit') {
          if (field.type === 'checkbox') {
            hasCheckbox = true;
            if (field.checked) {
              checkboxGroupChecked = true;
            }
          } else {
            countableFields++;
            if (field.value.trim() !== '') {
              filledFields++;
            }
          }
        }
      });

      if (hasCheckbox) {
        countableFields++;
        if (checkboxGroupChecked) {
          filledFields++;
        }
      }
    });

    const progress = (filledFields / countableFields) * 100;
    if (progressBar) progressBar.style.width = progress + '%';
  }

  if (progressBar) {
    progressBar.style.width = '0%';

    fields.forEach(field => {
      field.addEventListener('input', updateProgressBar);
      field.addEventListener('change', updateProgressBar);
    });

    updateProgressBar();
  }

  // === Topic Dropdown ===
  const topicDropdown = document.getElementById("topicDropdown");
  const selectedTopic = document.getElementById("selectedTopic");
  const topicArrow = document.getElementById("topic-arrow");
  const topicList = document.getElementById("topicList");
  const hiddenTopic = document.getElementById("hiddenTopic");

  if (topicDropdown && selectedTopic && topicArrow && topicList && hiddenTopic) {
    const arrowDown = topicArrow.querySelector(".arrow-down");
    const arrowUp = topicArrow.querySelector(".arrow-up");
    const selectedText = selectedTopic.querySelector(".selected-text");

    // Toggle dropdown on click
    selectedTopic.addEventListener("click", () => {
      const isOpen = topicList.style.display === "block";
      topicList.style.display = isOpen ? "none" : "block";
      arrowDown.style.display = isOpen ? "inline-flex" : "none";
      arrowUp.style.display = isOpen ? "none" : "inline-flex";
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", function (e) {
      if (!topicDropdown.contains(e.target)) {
        topicList.style.display = "none";
        arrowDown.style.display = "inline-flex";
        arrowUp.style.display = "none";
      }
    });

    // Select option
    document.querySelectorAll("#topicList .dropdown-option").forEach(option => {
      option.addEventListener("click", function () {
        const value = this.dataset.value;
        selectedText.textContent = value;
        hiddenTopic.value = value;

        topicList.style.display = "none";
        arrowDown.style.display = "inline-flex";
        arrowUp.style.display = "none";
      });
    });
  }
});
